module.exports = __webpack_public_path__ + "assets/img/jykj_img1.7c9cd8db.png";